/* tslint:disable */
/* eslint-disable */
/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InlineResponse2003OffersStatus
 */
export interface InlineResponse2003OffersStatus {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003OffersStatus
     */
    total?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003OffersStatus
     */
    unpublished?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003OffersStatus
     */
    published?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse2003OffersStatus
     */
    closed?: number;
}

export function InlineResponse2003OffersStatusFromJSON(json: any): InlineResponse2003OffersStatus {
    return InlineResponse2003OffersStatusFromJSONTyped(json, false);
}

export function InlineResponse2003OffersStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse2003OffersStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': !exists(json, 'total') ? undefined : json['total'],
        'unpublished': !exists(json, 'unpublished') ? undefined : json['unpublished'],
        'published': !exists(json, 'published') ? undefined : json['published'],
        'closed': !exists(json, 'closed') ? undefined : json['closed'],
    };
}

export function InlineResponse2003OffersStatusToJSON(value?: InlineResponse2003OffersStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'unpublished': value.unpublished,
        'published': value.published,
        'closed': value.closed,
    };
}


